import {UseStorageOptions, UseStorageResult, useStorage} from './useStorage';

export function useLocalStorage<T>(key: string, initialValue?: T, options?: UseStorageOptions): UseStorageResult<T> {
  return useStorage<T>(globalThis.localStorage, key, initialValue, options);
}
